import { Component, Output, Input, EventEmitter } from "@angular/core";

@Component({
  selector: "multi-checkbox-selection",
  templateUrl: "./multi-checkbox-selection.html",
  styleUrls: ["./multi-checkbox-selection.scss"],
})
export class MultiCheckboxSelectionComponent {
  @Input()
  data: { name: string; value: [string | number] }[];

  @Input()
  selected: { name: string; value: [string | number] }[] = [];

  @Output()
  valueChange = new EventEmitter<
    { name: string; value: [string | number] }[]
  >();

  onCheckChange(state, val: { name: string; value: [string | number] }) {
    let newSelection = [...this.selected];
    if (state == false) {
      newSelection.splice(newSelection.indexOf(val), 1);
    } else {
      newSelection.push(val);
    }

    this.valueChange.emit(newSelection);
  }
  onSelectAll() {
    this.valueChange.emit(this.data);
  }
  onDeselectAll() {
    this.valueChange.emit([]);
  }
}
